import ResponsiveContainer from "../components/responsive-container";
import ResponsiveContent from "../components/responsive-content";
import { useMessages } from "../language/language";
import "./not-found-page.less";

export default function NotFoundPage() {
  const msg = useMessages();
  const fullLocation = location.pathname;

  return <ResponsiveContainer className="not-found-page" centerContents={true}>
    <ResponsiveContent className="not-found-content">
      <div className="row top">
        <div className="comet" />
        <div className="star" />
        <div className="sun" />
      </div>
      <div className="row content">
        <h1>404</h1>
      </div>
      <div className="row bottom">
        <div className="section left">
          <div className="star" />
          <div className="group">
            <div className="star" />
            <div className="planet" />
          </div>
        </div>
        <div className="section middle">
          <div className="space-lama" />
        </div>
        <div className="section right">
          <div className="star" />
          <div className="earth" />
        </div>
      </div>
    </ResponsiveContent>
  </ResponsiveContainer>
}